import type { EffectCallback } from 'react';
import { useEffect, useRef } from 'react';

// avoids double execution due to StrictMode - particularly useful if useEffect has side effects
export function useEffectOnce(effect: EffectCallback) {
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!initializedRef.current) {
      initializedRef.current = true;
      // We have to cheat here by looking at the environment because if the effect returns
      // a cleanup function, it must not be returned until the *second* time for the dev
      // environment.  import.meta.env.DEV is true only under a Vite dev server, which since
      // issue #3447 means Storybook and Vitest (StrictMode double-invokes there); the app
      // itself is always a production build where the useEffect only runs once.
      if (!import.meta.env.DEV) {
        return effect();
      }
    } else {
      if (import.meta.env.DEV) {
        return effect();
      }
    }
    // eslint-disable-next-line
  }, []);
}
